import { useEffect, useRef, useState } from 'react';
import { Outlet, useMatches } from 'react-router';

import { Header } from './components/header';
import Sidebar from './components/sidebar';
import PageWrapper from '@/routes/page-wrapper';

interface isCollapsedProps {
  isDashboard: boolean;
}

const DashboardLayout = ({ isDashboard }: isCollapsedProps) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(isDashboard);

  const sidebarRef = useRef<HTMLDivElement>(null); // Ref for sidebar

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    setIsExpanded(true);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
      setIsSidebarOpen(false); // Close sidebar if click is outside
    }
  };

  const handleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    setIsExpanded(isDashboard);
  }, [isDashboard]);

  useEffect(() => {
    if (isSidebarOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSidebarOpen]);

  return (
    <PageWrapper isTransition>
      <div className="relative z-10 flex min-h-svh w-full px-6 gap-6">
        <Sidebar isExpanded={isExpanded} toggleSidebar={toggleSidebar} handleExpanded={handleExpanded} />

        <div className="flex flex-col w-full h-full">
          <Header />

          <main className="flex-1">
            <Outlet />
          </main>
        </div>
      </div>
    </PageWrapper>
  );
};

export default DashboardLayout;
